import { render, staticRenderFns } from "./v4.vue?vue&type=template&id=4401b7f2&"
import script from "./v4.vue?vue&type=script&lang=js&"
export * from "./v4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports